import React from 'react';
import GlobalModal from './GlobalModal';

const ModalContainer: React.FC = () => {
  return <GlobalModal />;
};

export default ModalContainer;
